import React from 'react';
import ForgeTrustIcon from '@tcs/common/components/atoms/Logo';
import useStyles from './style';

interface Props {
  navbarOpen: boolean;
  isMobile: boolean;
}

const Logo = ({ navbarOpen = true, isMobile }: Props) => {
  const classes = useStyles(undefined);
  const logo = (
    <div className={classes.logo}>
      <ForgeTrustIcon data-test-id="forge-icon" />
    </div>
  );

  if (isMobile) return logo;
  return navbarOpen ? logo : null;
};

export default Logo;
